var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInsider)?_c('div',{staticStyle:{"height":"100%"}},[_c('depart-list')],1):_c('div',{staticStyle:{"height":"100%"}},[_c('products-list',{staticStyle:{"padding":"20px 30px 12px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }